import type {
  MaintenanceSlaInterventionMode,
  MaintenanceSlaScopeInterventionMode,
  MaintenanceSlaScopeOption,
} from '~/app/landing/sla/oems/components/MaintenanceSlaContract/types';

export type ScopeClaim = {
  partnerName: string;
  relationshipId: string;
  interventionMode: MaintenanceSlaScopeInterventionMode | null;
};

function normalizeHeaderMode(
  mode: MaintenanceSlaInterventionMode | null,
): MaintenanceSlaInterventionMode {
  return mode ?? 'BOTH';
}

export function effectiveScopeInterventionMode(
  scopeMode: MaintenanceSlaScopeInterventionMode | null | undefined,
  headerMode: MaintenanceSlaInterventionMode | null,
): MaintenanceSlaScopeInterventionMode | null {
  if (scopeMode != null) {
    return scopeMode;
  }
  const header = normalizeHeaderMode(headerMode);
  if (header === 'ONSITE' || header === 'REMOTE') {
    return header;
  }
  return null;
}

export function scopeInterventionModesOverlap(
  left: MaintenanceSlaScopeInterventionMode | null,
  right: MaintenanceSlaScopeInterventionMode | null,
): boolean {
  if (left == null || right == null) {
    return true;
  }
  return left === right;
}

export function listScopeClaimsForOption(
  option: MaintenanceSlaScopeOption,
): ScopeClaim[] {
  if (option.claims?.length) {
    return option.claims.map((claim) => ({
      partnerName: claim.partnerName,
      relationshipId: claim.relationshipId,
      interventionMode: claim.interventionMode ?? null,
    }));
  }
  if (option.claimedBy) {
    return [
      {
        ...option.claimedBy,
        interventionMode: option.claimedBy.interventionMode ?? null,
      },
    ];
  }
  return [];
}

export function findBlockingScopeClaim(
  option: MaintenanceSlaScopeOption,
  ruleScopeMode: MaintenanceSlaScopeInterventionMode | null | undefined,
  headerMode: MaintenanceSlaInterventionMode | null,
): ScopeClaim | undefined {
  const ruleEffective = effectiveScopeInterventionMode(
    ruleScopeMode,
    headerMode,
  );
  return listScopeClaimsForOption(option).find((claim) =>
    scopeInterventionModesOverlap(
      ruleEffective,
      claim.interventionMode ?? null,
    ),
  );
}

export function scopeRowIdentityKey(
  dimension: string,
  effect: string,
  value: string,
  ruleScopeMode: MaintenanceSlaScopeInterventionMode | null | undefined,
  headerMode: MaintenanceSlaInterventionMode | null,
): string {
  const mode = effectiveScopeInterventionMode(ruleScopeMode, headerMode);
  return `${dimension}::${effect}::${value}::${mode ?? 'ANY'}`;
}
